import React from 'react';
import { graphql } from 'gatsby';
import DataGovernanceForFinance from '../../../pages-en/white-papers/data-governance-for-finance';
import SEO from 'components/SEO';
import data from '../../../pages-en/white-papers/data-governance-for-finance/data.json';

export default DataGovernanceForFinance;

export const Head = ({ location }) => <SEO {...data.head} {...location} />;

export const query = graphql`
  query ($pagePath: String, $lang: String) {
    introImagesJson(page: { eq: $pagePath }) {
      ...IntroImages
    }
    allContentfulArticlePreview(
      filter: {
        node_locale: { eq: $lang }
        pagesToDisplayOn: { elemMatch: { content: { eq: $pagePath } } }
      }
      sort: { publishDate: DESC }
    ) {
      nodes {
        ...ArticlePreview
      }
    }
  }
`;
